import type { Announcement } from '../types';

export const a_2026_07_06: Announcement = {
  id: '2026-07-06-conclusions-replique',
  date: '2026-07-06',
  layout: 'spotlight',
  kicker: 'Mise à jour produit · 6 juillet 2026',
  title: "Hector s'améliore : une nouvelle manière de rédiger vos conclusions en réplique",
  navLabel: 'Conclusions en réplique',
  subtitle: '',
  intro: [
    "Dans Word, l'onglet Génération vous propose désormais un parcours dédié aux conclusions en réplique. Hector analyse vos écritures et les dernières conclusions adverses, puis vous présente un plan de riposte avant toute rédaction.",
    "Une fois le plan ajusté à votre main, Hector rédige la réplique en reprenant fidèlement vos écritures précédentes et en signalant chaque ajout par une barre verticale en marge gauche. D'un coup d'œil, vous voyez ce qui est nouveau par rapport à vos premières conclusions.",
  ],
  videoCaption: 'Découvrez le nouveau parcours en vidéo',
  // Embed YouTube — https://www.youtube.com/watch?v=jcLF1IY82LA
  video: { provider: 'youtube', id: 'jcLF1IY82LA' },
  sections: [
    {
      label: 'Comment cela fonctionne',
      features: [
        {
          id: 'plan-de-riposte',
          title: 'Le plan de riposte',
          body: {
            kind: 'subpoints',
            subpoints: [
              {
                title: 'Repris',
                description:
                  "Les moyens déjà développés, que l'on maintient tels quels.",
              },
              {
                title: 'Enrichi',
                description:
                  "Les moyens existants qu'Hector renforce : nouveaux angles, faits et précisions.",
              },
              {
                title: 'Nouveau',
                description:
                  "Les moyens inédits, pour lesquels Hector suit le même parcours de recherche que pour la rédaction d'un acte.",
              },
            ],
          },
        },
        {
          id: 'redaction-acte',
          title: "La rédaction de l'acte",
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Le plan vous est présenté avant la rédaction : vous l'ajustez, vous complétez, vous écartez ce qui ne vous convient pas.",
              "À partir du plan validé, Hector rédige les conclusions en réplique en reprenant vos écritures initiales et en marquant les ajouts d'une barre verticale sur le côté gauche, pour distinguer d'un regard ce qui vient s'ajouter à vos précédentes conclusions.",
            ],
          },
        },
      ],
    },
    {
      label: 'Où la retrouver',
      features: [
        {
          id: 'disponibilite',
          title: 'Disponible en droit privé',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "En famille, civil, commercial et social, au fond, en appel, en référé et en urgence, ainsi que devant le juge de l'exécution.",
              "À repérer au badge « Nouveau » dans la liste des actes, partout où vous rédigez déjà des conclusions en défense.",
            ],
          },
        },
      ],
    },
  ],
};
